module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }



//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/node_modules/atoa/atoa.js
// module id = ../../../../atoa/atoa.js
// module chunks = common